module.exports = __webpack_public_path__ + "img/کلاسیک.2aa56b78.jpg";